import React, {useState, useEffect, useLayoutEffect} from 'react';
import { Link, useNavigate, useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import './market.css';
import axios from 'axios';


const Mbar=()=>{
    const [turn, setturn] = useState(1);
    const [msear, setmsear] = useState(false);
    const [rediz, setrediz] = useState(true);
    const furi = useSelector(state=>state.mahena);
    const navi = useNavigate();
    const noban = useLocation();
   
    const nout = async ()=>{
        const kake = await axios.get('/api/logout').then(dadi=>{if(dadi.data.logend == "out"){
           
            window.location.replace("/");
            modore();
        }}).catch(e=>console.log("logout"));
    };

    useEffect(()=>{
       const coss = document.querySelector('input[name="samo"]');
       coss.value = "";
   
    },[]);

    useEffect(()=>{
        if(document.querySelector(".byunsin")){
            document.querySelector(".mtip").classList.remove("byunsin");
            document.querySelector(".mtip").classList.remove("insearch");
            setmsear(false);
           };
    },[rediz, noban.pathname]);

    const meom =()=>{
        if(document.querySelector(".stopflow")){
            document.querySelector(".smgin").classList.remove("inflg");
            document.querySelector("body").classList.remove("stopflow");
        };
    };

    useLayoutEffect(()=>{
        window.addEventListener("popstate", meom);
        return ()=>window.removeEventListener("popstate",meom);
    },[]);

    const nao = async (e)=>{
       e.preventDefault();
    
        const texts = e.target.samo.value.trim();
        if(texts.length == 0){return;};
        if(noban.state?.yi == texts){ return;};
        const aisidari = texts.toLowerCase().split(" ");
        const params = {sea : aisidari, jun : 1};
    
        const yameda = await axios.get('/api/engine',{params}).then(a=>{ return a.data}).catch(e=>console.log("d-generation")); 
        
        navi('/under/search', {state : {yo : yameda, ya : params, yi : texts}});
    };

    const smguide=(e)=>{
        document.querySelector(".smgin").classList.add("inflg");
        document.querySelector("body").classList.add("stopflow");
    };
    const modore=(e)=>{
        document.querySelector(".smgin").classList.remove("inflg");
        document.querySelector("body").classList.remove("stopflow");
    };
    const msearch=(e)=>{
        if(msear == false){
        document.querySelector(".mtip").classList.add("insearch");
        setTimeout(()=>{document.querySelector(".mtip").classList.add("byunsin")}, 50);
        setmsear(true);
        }else{
            document.querySelector(".mtip").classList.remove("byunsin");
            setTimeout(()=>{document.querySelector(".mtip").classList.remove("insearch")}, 80);
         
            setmsear(false);
        };
    };

    const redia=(e)=>{
        // e.preventDefault();
        setrediz(!rediz);
    };

    return(
    <>
    <div className='mtoufa'>
        
        <span onClick={smguide} className='mhambur'><img src={process.env.PUBLIC_URL+'/menu-c.png'}/></span>   
        <span className='mlogo'><Link to="/" className='mlogoin' onClick={redia}><img src={process.env.PUBLIC_URL+'/sidbb.png'} className='moinbi'/></Link></span>
        <span onClick={msearch} className='msearcher'>{msear == true ? <img src={process.env.PUBLIC_URL+'/modore2.png'} className='omae'/> : <img src={process.env.PUBLIC_URL+'/search-m3.png'} className='omae'/>}</span>
    </div>

    <div className='smgin'>
        <div className='minsse'>
             <span onClick={modore} className='minmo'><img src={process.env.PUBLIC_URL+'/undo2-m.png'} className='momae'/></span>
             <span onClick={()=>{modore(); window.history.states = {page : 1, molan : "allaround", nopi: 0}; window.history.tates = null;}} className='mlogo'><Link to='/' className='mlogoin'><img src={process.env.PUBLIC_URL+'/sidbb.png'} className='moinbi'/></Link></span>
        </div>
        <div className='minner'>
            {furi?.id ? <div class='tip3' style={{position:"relative"}}>
                <span class='maruho' onClick={modore}>
                    <Link to='under/pro' class='maruha maruha2'>{furi.id}</Link>
                </span>
                <span onClick={nout} class='maruho'>
                    <img src={process.env.PUBLIC_URL+'/logout.png'}/><br/>
                    로그아웃
                    </span>
                </div> : <div class='tip3'  style={{position:"relative"}}>
                            <span onClick={modore}>
                                <Link to='join' class='maruha'><img src={process.env.PUBLIC_URL+'/login.png'}/><br/>로그인</Link>
                            </span>
                            <span onClick={modore}>
                                <Link to='/gayip' class="maruho"><img src={process.env.PUBLIC_URL+'/group.png'}/><br/>회원가입</Link>
                            </span>
                          </div>}
          
        </div>
        <div className='mguide'>
            <div className={turn == 1 ? 'mlist active' : 'mlist'} onClick={()=>{setturn(1); modore(); window.history.states = {page : 1, molan : "allaround", nopi: 0}; window.history.tates = null;}}>
                    
                        <span className='icon'>
                        <Link to="/" style={{textDecoration : "none", display:"block", height:"35px"}}>
                        <img src={process.env.PUBLIC_URL+'/ddola.png'} style={{height:"100%"}}/></Link>
                        </span>
                        <span className='text'>
                      
                        </span>
                    
            </div>
            <div className={turn == 2 ? 'mlist active' : 'mlist'} onClick={()=>{setturn(2); modore(); window.history.states = {page : 1, molan : "allaround", nopi: 0}; window.history.tates = null;}}>
                    
                        <span className='icon'> 
                    <Link to="/under/prw" className='nebud'>공모전</Link>
                        </span>
                        {/* <span className='text'>   
                        </span> */}
                    
            </div>
            <div className={turn == 3 ? 'mlist active' : 'mlist'} onClick={()=>{setturn(3); modore(); window.history.states = {page : 1, molan : "allaround", nopi: 0}; window.history.tates = null;}}>
                    <a>
                        <span className='icon'>
                        <Link to="/under/pra" className='nebud'>대외활동</Link>
                        </span>
                        <span className='text'>
                        </span>
                    </a>
            </div>
            <div className={turn == 4 ? 'mlist active' : 'mlist'} onClick={()=>{setturn(4); modore(); window.history.states = {page : 1, molan : "allaround", nopi: 0}; window.history.tates = null;}}>
                    <a>
                        <span className='icon'>
                        <Link to="/under/pry" className='nebud'>교육</Link> 
                        </span>
                        <span className='text'>
                        </span>
                    </a>
            </div>
            <div className={turn == 5 ? 'mlist active' : 'mlist'} onClick={()=>{setturn(5); modore(); window.history.states = {page : 1, molan : "allaround", nopi: 0}; window.history.tates = null;}}>
                    <a>
                        <span className='icon'>
                        <Link to="/targets" className='nebud'>인사이트</Link>
                        </span>
                        <span className='text'> 
                        </span>
                    </a>
            </div>
            {/* <div className='indicator'></div> */}
        </div>
        <div className='madv'>
            <span onClick={modore}><Link to="/sin" className='netud'>공모전등록</Link></span>
            <span onClick={modore}><Link to="/son" className='netud'>광고안내</Link></span>
        </div>
    </div>
    
    <div className='mtip' >
        <div className='tip0' style={{width:"100%" , boxSizing: "border-box"}}>
        <div className='tip1' style={{width:"100%"}}>
            <form onSubmit={nao} className='tipa'> 
            <input placeholder='검색하고 돌파하세요' type='text' name='samo' className='mtipfa' />
            <input type='submit' className='super' value={""}/>
            {/* <span onClick={nao} className='super'><img src={process.env.PUBLIC_URL+'/search-m3.png'} style={{width:"100%"}}/></span> */}
            </form>
        </div>
        </div>
    </div>
    </>
    );
}

export default Mbar;